// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".body{background-color:#fafbfc;border-bottom-left-radius:.25rem;border-bottom-right-radius:.25rem}.national-selector{margin-bottom:0}.title{color:#506784;letter-spacing:1px;font-size:12px}.states-selector{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
